import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { DialogService } from '@app/core/_services/dialog.service'
import { MessageModule } from 'primeng/message'

const HOST_RECRUITMENT_BANNER_NAME = 'Group Meeting: Host Recruitment'
const HOST_RECRUITMENT_BANNER_SOURCE = 'groupMeetingHostRecruitmentBanner'

@Component({
    selector: 'fm-host-recruitment-banner',
    imports: [MessageModule],
    templateUrl: './host-recruitment-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HostRecruitmentBannerComponent {
    @Output() dismissBanner = new EventEmitter<void>()

    public pMessageScopedToken = {
        content: {
            gap: '0.5rem',
            padding: '0rem 0.75rem',
        },
    }

    constructor(
        private analyticsService: AnalyticsService,
        private dialogService: DialogService,
    ) {}

    ngOnInit(): void {
        this.analyticsService.logViewedBannerEvent(HOST_RECRUITMENT_BANNER_NAME, {
            source: HOST_RECRUITMENT_BANNER_SOURCE,
        })
    }

    openHostRecruitmentDialog(): void {
        this.analyticsService.logGroupMeetingClick(
            'learnMoreAboutHostRecruitment',
            HOST_RECRUITMENT_BANNER_SOURCE,
        )
        this.dialogService.openGroupMeetingHostRecruitmentDialog()
    }

    onDismissBanner(): void {
        this.analyticsService.logGroupMeetingClick(
            'dismissHostRecruitmentBanner',
            HOST_RECRUITMENT_BANNER_SOURCE,
        )
        this.dismissBanner.emit()
    }
}
